import React from 'react'
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap'
import _ from 'lodash'

import CurrencyUtils from 'PMT/utils/CurrencyUtils'

const StatsTable = ({name, thead, iterator, data, currencyCode}) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <i className="fa fa-bar-chart-o fa-fw"></i> {name}
    </div>
    <div className="panel-body">
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            {thead.map((th) => (
              <th className="text-right">{th}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {iterator.map((iteratee) => {
            if (_.isEmpty(data[iteratee.value]) && _.isEmpty(data[iteratee.value]) && _.isEmpty(data[iteratee.value])) {
              return null
            }

            return (
              <tr key={`sums-${iteratee.value}`}>
                <td>{iteratee.label}</td>
                <td className="text-right">
                  {!_.isEmpty(data[iteratee.value]) ?
                    data[iteratee.value].nbOrders :
                    `-`
                  }
                </td>
                <td className="text-right">
                  {!_.isEmpty(data[iteratee.value]) ?
                      CurrencyUtils.formatMillionPriceWithCurrency(
                          data[iteratee.value].turnoverTTC, currencyCode) :
                    `-`
                  }
                </td>
                <td className="text-right">
                  {!_.isEmpty(data[iteratee.value]) ?
                      CurrencyUtils.formatMillionPriceWithCurrency(
                          data[iteratee.value].averageTTC, currencyCode) :
                    `-`
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  </div>
)

StatsTable.propTypes = {
  name: PropTypes.string.isRequired,
  thead: PropTypes.array.isRequired,
  iterator: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
}

export default StatsTable
